export default __webpack_public_path__ + "static/media/slider-sosmed.73c25312.png";